module.exports = __webpack_public_path__ + "assets/img/7.9462e0dd.png";